import React from 'react';
import PropTypes from 'prop-types';

import { Button, Icon, Loader, MaterialHint } from 'shared/components';
import BackgroundLayout from 'pages/_layouts/BackgroundLayout';


import theme from './ReschedulingOffer.scss';

const propTypes = {
  intl: PropTypes.shape({
    formatMessage: PropTypes.func.isRequired,
  }).isRequired,
  acceptReschedulingOffer: PropTypes.func.isRequired,
  declineReschedulingOffer: PropTypes.func.isRequired,
  isPending: PropTypes.bool.isRequired,
  isExpired: PropTypes.bool.isRequired,
  isDeclined: PropTypes.bool.isRequired,
  isAccepted: PropTypes.bool.isRequired,
  message: PropTypes.string.isRequired,
  organizationName: PropTypes.string.isRequired,
};

const ReschedulingOffer = ({
 isPending,
 intl,
 message,
 organizationName,
 acceptReschedulingOffer,
 declineReschedulingOffer,
 isExpired,
 isDeclined,
 isAccepted,
}) => (
  <Choose>
    <When condition={ isPending }>
      <Loader height="80" width="80" color="#282828" />
    </When>
    <Otherwise>
      <BackgroundLayout>
        <Choose>
          <When condition={ isExpired }>
            <div className={ theme.root }>
              <div className={ theme.main }>
                <div className={ theme.orgName }> { organizationName } </div>
                <Icon name="clock-outline" className={ theme.expiredIcon } />
              </div>
              <div className={ theme.content } dangerouslySetInnerHTML={{ __html: message }} />
            </div>
          </When>

          <When condition={ isAccepted || isDeclined }>
            <div className={ theme.root }>
              <div className={ theme.main }>
                <div className={ theme.orgName } > { organizationName } </div>
                <Icon name="circle-check-fill" className={ theme.icon } />
              </div>
              <div className={ theme.content } dangerouslySetInnerHTML={{ __html: message }} />
            </div>
          </When>
          <Otherwise>
            <div className={ theme.root }>
              <div className={ theme.main }>
                <div className={ theme.orgName } > { organizationName } </div>
                <Icon name="cyclic-doc" className={ theme.icon } />
              </div>
              <div className={ theme.content } dangerouslySetInnerHTML={{ __html: message }} />
              <div className={ theme.buttons }>
                <MaterialHint
                  placement="top"
                  title={ intl.formatMessage({
                    id: 'DynamicRescheduling.ConfirmaitonPage.DeclineButton.Tooltip',
                    defaultMessage: '** Decline appointment rescheduling',
                  }) }
                >
                  <div className={ theme.declineBtn }>
                    <Button
                      testId="decline-reschedule-offer-button"
                      label={ intl.formatMessage({
                        id: 'DynamicRescheduling.ConfirmaitonPage.DeclineOfferButton.Label',
                        defaultMessage: '** No',
                      }) }
                      onClick={ declineReschedulingOffer }
                      className={ theme.declineBtn }
                    />
                  </div>
                </MaterialHint>
                <MaterialHint
                  placement="top"
                  title={ intl.formatMessage({
                    id: 'DynamicRescheduling.ConfirmaitonPage.ConfirmButton.Tooltip',
                    defaultMessage: '** Accept appointment rescheduling',
                  }) }
                >
                  <div className={ theme.acceptBtn } >
                    <Button
                      testId="accept-reschedule-offer-button"
                      label={ intl.formatMessage({
                        id: 'DynamicRescheduling.ConfirmaitonPage.AcceptOfferButton.Label',
                        defaultMessage: '** Yes',
                      }) }
                      onClick={ acceptReschedulingOffer }
                      className={ theme.acceptBtn }
                    />
                  </div>
                </MaterialHint>
              </div>
            </div>
          </Otherwise>
        </Choose>
      </BackgroundLayout>
    </Otherwise>
  </Choose>

);

ReschedulingOffer.propTypes = propTypes;

export default ReschedulingOffer;
